module.exports = __webpack_public_path__ + "img/image_default.1fcbd552.png";